import { JSX } from 'react'

import { IconProps } from '../../icon'

const Offline: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M23.9917 35.7853C25.5771 35.7853 26.8624 34.5001 26.8624 32.9146C26.8624 31.3292 25.5771 30.044 23.9917 30.044C22.4063 30.044 21.1211 31.3292 21.1211 32.9146C21.1211 34.5001 22.4063 35.7853 23.9917 35.7853Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.8922 36.661C11.3995 36.1775 11.3136 35.466 11.7004 35.0718L35.5999 10.7138C35.9867 10.3196 36.6997 10.392 37.1925 10.8755C37.6853 11.3589 37.7712 12.0705 37.3844 12.4647L13.4848 36.8227C13.098 37.2169 12.385 37.1445 11.8922 36.661Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.2866 17.0497C35.589 17.7494 36.8234 18.5841 37.9677 19.5457C38.4926 19.9886 39.2636 19.923 39.7065 19.398C40.1494 18.8731 40.0838 18.1022 39.5589 17.6593H39.5425C38.4545 16.7437 37.2925 15.9319 36.0727 15.2294L34.2866 17.0497ZM32.7347 13.634C33.5624 13.9543 34.3727 14.3202 35.1614 14.7303L33.3508 16.5757C32.5353 16.1872 31.6964 15.8499 30.8393 15.5658L32.7347 13.634ZM31.7003 13.2604C29.2316 12.4316 26.6276 12 23.9918 12C18.3161 12 12.7881 14.0176 8.44114 17.6593C7.91623 18.1022 7.85061 18.8731 8.29351 19.398C8.53957 19.6933 8.88404 19.8409 9.22852 19.8409C9.50738 19.8409 9.78624 19.7425 10.0159 19.5457C13.92 16.2649 18.8739 14.4605 23.9918 14.4605C25.9551 14.4605 27.8943 14.7261 29.7593 15.2386L31.7003 13.2604Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.7857 21.6369C31.2052 22.2244 32.5378 23.0269 33.7355 24.0239C34.2604 24.4668 35.0314 24.4011 35.4743 23.8762C35.9172 23.3513 35.8516 22.5803 35.3266 22.1374C34.1949 21.1875 32.9521 20.3885 31.6334 19.7539L29.7857 21.6369ZM27.9918 18.4678C28.9019 18.6812 29.7937 18.9664 30.658 19.3201L28.7597 21.2548C27.8319 20.9467 26.8735 20.7276 25.897 20.6029L27.9918 18.4678ZM26.8197 18.2345C25.8885 18.0819 24.9427 18.0037 23.9917 18.0037V18.0201C19.8252 18.0201 15.7899 19.4965 12.624 22.1702C12.0991 22.6131 12.0335 23.3841 12.4764 23.909C12.7224 24.1879 13.0669 24.3519 13.4114 24.3519C13.6902 24.3519 13.9691 24.2535 14.1988 24.0567C16.9218 21.7438 20.3993 20.4807 23.9753 20.4807C24.1851 20.4807 24.3944 20.485 24.6031 20.4937L26.8197 18.2345Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.0054 26.509C26.7567 26.7113 28.4076 27.4433 29.7331 28.6169C29.9628 28.8301 30.258 28.9286 30.5533 28.9286C30.8978 28.9286 31.2258 28.7973 31.4719 28.5185C31.9148 28.0099 31.882 27.239 31.3735 26.7797C30.1268 25.6647 28.6483 24.8629 27.062 24.413L25.0054 26.509ZM22.4712 24.0944C22.9719 24.0259 23.4798 23.9911 23.9918 23.9911H24.0247C24.6621 23.9911 25.2949 24.0456 25.9164 24.1527L23.6536 26.4588C21.6658 26.5399 19.77 27.3006 18.2834 28.6169C18.1276 28.7576 17.9472 28.8506 17.7587 28.8972L22.4712 24.0944ZM20.6794 24.4927C19.1961 24.9547 17.8192 25.7278 16.643 26.7797C16.1345 27.239 16.0853 28.0099 16.5446 28.5185C16.5744 28.5515 16.6056 28.5826 16.6379 28.6117L20.6794 24.4927Z'
      fill='black'
    />
  </svg>
)

export default Offline
